import {
  LegacyPage,
  Model,
  LoadingContainer,
  Panels,
  Bar,
} from 'peach/components'
import { useParams } from 'peach/router'

import {
  useInternalListTemplateVersionsByDescriptor,
  useInternalGetTemplateDescriptor,
} from 'core/types'

import TemplateEditor from '../TemplateEditor/TemplateEditor'

const TemplateSubject = () => {
  const { companyId, templateId } = useParams<{
    companyId?: string
    subjectKey?: string
    channelKey?: string
    templateId?: string
  }>()

  const {
    data: template,
    isLoading: templateLoading,
    error: templateError,
  } = useInternalListTemplateVersionsByDescriptor({
    companyId,
    descriptorId: templateId,
  })

  const {
    data: descriptor,
    isLoading: descriptorLoading,
    error: descriptorError,
  } = useInternalGetTemplateDescriptor({
    companyId,
    descriptorId: template?.descriptorId,
  })

  const onSaveTemplate = (newTemplateData, diff) => {
    console.info(newTemplateData, diff)
    // Add actual save implementation here
  }

  const editTemplate = template && descriptor && (
    <TemplateEditor
      descriptor={descriptor}
      onSaveTemplate={onSaveTemplate}
      template={template}
      triggerButtonLabel='Edit Template'
    />
  )

  return (
    <LoadingContainer
      error={templateError ?? descriptorError}
      isLoading={templateLoading || descriptorLoading}
    >
      <Panels header={<Bar right={editTemplate} title='Template' />}>
        <LegacyPage.Full>
          <Model.Item json={template} title='Template' />
          <Model.Item json={descriptor} noLink title='Descriptor' />
        </LegacyPage.Full>
      </Panels>
    </LoadingContainer>
  )
}

export default TemplateSubject
